import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolQuotesAction } from '../symbolQuotes.action';
import { IQuoteClientSymbolRow } from '../symbolQuotes.interface';

type IDependencies = IClientApiDependencySegment;

/** Thin paginated loader for the server route's client-symbol rows (decoupled from the infinity grid). */
export const loadServerSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, { api }) =>
  action$.pipe(
    isTypeOfAndGetPayload(SymbolQuotesAction.loadServerSymbols.started),
    mergeMap((params) =>
      api.getServerClientSymbolList({
        serverId: params.serverId,
        symbolGroup: params.symbolGroup,
        search: params.search,
        limit: params.limit,
        skip: params.skip,
      }).pipe(
        mergeMap((response) => {
          const items: IQuoteClientSymbolRow[] = response.symbols.map((symbol) => ({
            clientSymbolName: symbol.name,
            coreSymbolName: symbol.coreSymbol.name,
            scheduleName: symbol.schedule?.name,
          }));
          return [SymbolQuotesAction.loadServerSymbols.done({ params, result: { items, total: response.filteredCount } })];
        }),
        catchApiError((error) => [
          SymbolQuotesAction.loadServerSymbols.failed({ params, error }),
          createApiErrorNotification(error),
        ]),
      ),
    ),
  );
